import { BlankSlate, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ForbiddenPage = () => {
  const { navigation } = useNavigation()
  return (
    <ResponsivePage.Body variant="narrow">
      <BlankSlate
        illustration="sign-post"
        title={i18n.t('marketplace.forbidden.title')}
        description={i18n.t('marketplace.forbidden.description')}
      >
        <Button.Router
          to={navigation.discover.marketplace.fullPath()}
          type="secondary"
          iconName="arrow-left"
        >
          {i18n.t('marketplace.integrations.title')}
        </Button.Router>
      </BlankSlate>
    </ResponsivePage.Body>
  )
}

export default ForbiddenPage
